// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs-module--breadcrumbs--_4BRX","chevron":"breadcrumbs-module--chevron--12vY8","link":"breadcrumbs-module--link--1rzZJ"};